<ng-container *ngIf="isSuccess">
	<div class="page-wrapper">
		<div class="container-fluid p-0">
			<div class="row">
				<div class="col-12">
					<div class="login-card">
						<div>
							<div>
								<a class="logo" routerLink="/">
									<img
										class="img-fluid for-light"
										src="assets/images/logo/Tasyire-logo.png"
										alt="looginpage"
									/>
								</a>
							</div>
							<div class="login-main">
								<form class="theme-form" (ngSubmit)="Submit()">
									<h4>Create Your Password</h4>
									<div class="form-group">
										<label class="col-form-label">New Password</label>
										<input
											class="form-control"
											[type]="show ? 'text' : 'password'"
											name="newpassword"
											required="true"
											[(ngModel)]="newpassword"
											placeholder="*********"
											(input)="validatePassword()"
										/>
										<div class="show-hide" (click)="showPassword()" *ngIf="!show">
											<span class="show"></span>
										</div>
										<div class="show-hide" (click)="showPassword()" *ngIf="show">
											<span class="Hide"></span>
										</div>
										<div *ngIf="passwordError" class="text text-{{ messageResponse.type }} mt-1">
											{{ messageResponse.message | translate }}
										</div>
									</div>
									<div class="form-group">
										<label class="col-form-label">Retype Password</label>
										<input
											class="form-control"
											type="password"
											name="confirmpassword"
											required="true"
											[(ngModel)]="confirmpassword"
											placeholder="*********"
										/>
									</div>
									<div *ngIf="!passwordError" class="text text-{{ messageResponse.type }} mt-1">
										{{ messageResponse.message }}
									</div>
									<div class="form-group mb-0">
										<div class="checkbox p-0">
											<input id="checkbox1" type="checkbox" />
											<label class="text-muted" for="checkbox1">Remember password</label>
										</div>
										<button
											*ngIf="!isButtonDisabled"
											class="btn btn-primary d-block w-100"
											[disabled]="!isSuccess"
											type="submit"
										>
											Done
										</button>
										<button
											*ngIf="isButtonDisabled"
											class="btn btn-primary d-block w-100"
											[disabled]="true"
											type="button"
										>
											Done
										</button>
									</div>
									<p class="mt-4 mb-0"><a class="ms-2" [routerLink]="'../login'">Login</a></p>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="isError">
	<!-- error-404 start-->
	<div class="error-wrapper" *ngIf="isError">
		<div class="container">
			<img class="img-100" src="assets/images/other-images/sad.png" alt="" />
			<div class="error-heading">
				<h2 class="headline font-danger">404</h2>
			</div>
			<div class="col-md-8 offset-md-2">
				<p class="sub-content">{{ error }}</p>
			</div>
			<div>
				<a class="btn btn-danger-gradien btn-lg" routerLink="/auth/login">BACK TO HOME PAGE</a>
			</div>
		</div>
	</div>
	<!-- error-404 end      -->
</ng-container>
